import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Outlet } from 'react-router-dom'
// import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import Header from '../components/Header';
// import LeftMenu from '../components/LeftMenu';
import Tabs from '../components/Tabs';
import { InteractionStatus } from '@azure/msal-browser';

const MapContainer = () => {
  const { inProgress } = useMsal();
  const navigate = useNavigate()
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None)
      navigate('/')
  }, [isAuthenticated, inProgress, navigate])

  if (isAuthenticated)
    return (
      <Box sx={{ flexGrow: 1 }}>
        <CssBaseline />
        <Paper elevation={3}>
          <Header title="Automatic Boundary Generation" />
        </Paper>
        <Tabs />
        <Grid container spacing={1} sx={{ height: 'calc(100vh - 10em)' }}>
          <Outlet />
        </Grid>
      </Box>
    );

    return <></>
}

export default MapContainer